import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import {
	Box,
	ToggleButton,
	ToggleButtonGroup,
	Typography,
} from "@mui/material";

export type BendResult = "OK" | "NOT_OK";

type Props = {
	label: string;
	value: BendResult | null;
	onChange: (value: BendResult | null) => void;
	disabled?: boolean;
};

export const BendTestResult = ({
	label,
	value,
	onChange,
	disabled = false,
}: Props) => (
	<Box>
		<Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.75 }}>
			{label}
		</Typography>
		<ToggleButtonGroup
			exclusive
			fullWidth
			disabled={disabled}
			value={value}
			onChange={(_, next: BendResult | null) => onChange(next)}
			sx={{
				// Large touch targets for tablet/phone operators
				"& .MuiToggleButton-root": {
					py: 1.5,
					fontSize: "1.05rem",
					fontWeight: 600,
				},
			}}
		>
			<ToggleButton
				value="OK"
				sx={{
					"&.Mui-selected": {
						backgroundColor: "success.main",
						color: "success.contrastText",
						"&:hover": { backgroundColor: "success.dark" },
					},
				}}
			>
				<CheckCircleIcon sx={{ mr: 1 }} />
				OK
			</ToggleButton>
			<ToggleButton
				value="NOT_OK"
				sx={{
					"&.Mui-selected": {
						backgroundColor: "error.main",
						color: "error.contrastText",
						"&:hover": { backgroundColor: "error.dark" },
					},
				}}
			>
				<CancelIcon sx={{ mr: 1 }} />
				Not OK
			</ToggleButton>
		</ToggleButtonGroup>
	</Box>
);
